import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { CheckCircle2 } from 'lucide-react';

const AuthConfirmed: React.FC = () => {
  const navigate = useNavigate();
  const { session, loading } = useAuth();
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (loading) return;
    if (session) {
      const t = setTimeout(() => {
        setShow(false);
        navigate('/', { replace: true });
      }, 2000);
      return () => clearTimeout(t);
    } else {
      navigate('/', { replace: true, state: { openAuth: true } });
    }
  }, [session, loading, navigate]);

  if (!show) return null;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4 text-center animate-in fade-in zoom-in duration-500">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-500/10 ring-2 ring-green-500/20">
          <CheckCircle2 className="h-8 w-8 text-green-500" />
        </div>
        <h1 className="text-xl font-semibold text-foreground">Email Confirmed!</h1>
        <p className="text-sm text-muted-foreground">Redirecting you to the dashboard...</p>
      </div>
    </div>
  );
};

export default AuthConfirmed;
